import { Mail, MapPin, Clock, Linkedin, Twitter, Github } from "lucide-react";

const ContactInfo = () => {
  return (
    <div className="md:w-1/2 p-8 md:p-12 gradient-bg text-white">
      <h3 className="text-2xl font-bold mb-6">Contact Information</h3>
      
      <div className="space-y-6">
        <div className="flex items-start">
          <div className="mt-1 mr-4 text-blue-600 bg-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
            <Mail className="h-4 w-4" />
          </div>
          <div>
            <h4 className="font-semibold mb-1">Email</h4>
            <p>info@karinfinity.com</p>
          </div>
        </div>
        
        <div className="flex items-start">
          <div className="mt-1 mr-4 text-blue-600 bg-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
            <MapPin className="h-4 w-4" />
          </div>
          <div>
            <h4 className="font-semibold mb-1">Location</h4>
            <p>San Francisco Bay Area, California</p>
          </div>
        </div>
        
        <div className="flex items-start">
          <div className="mt-1 mr-4 text-blue-600 bg-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
            <Clock className="h-4 w-4" />
          </div>
          <div>
            <h4 className="font-semibold mb-1">Hours</h4>
            <p>Monday - Friday: 9AM - 5PM PST</p>
          </div>
        </div>
      </div>
      
      <div className="mt-10">
        <h4 className="font-semibold mb-4">Follow Us</h4>
        <div className="flex space-x-4">
          <a href="#" className="bg-white text-blue-600 rounded-full w-10 h-10 flex items-center justify-center hover:bg-blue-600/10 transition-colors">
            <Linkedin className="h-5 w-5" />
          </a>
          <a href="#" className="bg-white text-blue-600 rounded-full w-10 h-10 flex items-center justify-center hover:bg-blue-600/10 transition-colors">
            <Twitter className="h-5 w-5" />
          </a>
          <a href="#" className="bg-white text-blue-600 rounded-full w-10 h-10 flex items-center justify-center hover:bg-blue-600/10 transition-colors">
            <Github className="h-5 w-5" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
